import {
  actualizarPeraca,
  crearPeraca,
  eliminarPeraca,
  getPeracas,
} from 'api/peraca'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'peracas'
export function useObtenerPeraca(buscar) {
  return useQuery(key, () => getPeracas(buscar))
}

export function useCrearPeraca() {
  const queryClient = useQueryClient()
  return useMutation(crearPeraca, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarPeraca() {
  const queryClient = useQueryClient()
  return useMutation(actualizarPeraca, {
    onSuccess: (_, value) => {
      const { id, values: peracaActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((peraca) => {
          let nuevoPeraca = peraca
          if (id === peraca.id) {
            nuevoPeraca = peracaActualizado
          }
          return nuevoPeraca
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarPeraca() {
  const queryClient = useQueryClient()
  return useMutation(eliminarPeraca, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (peraca) => peraca.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function usePeraca(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarPeraca } = useEliminarPeraca()
  const { mutateAsync: actualizarPeraca } = useActualizarPeraca()
  const { mutateAsync: crearPeraca } = useCrearPeraca()

  const handleCrearPeraca = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearPeraca(values)
      const message = `El periodo academico ${data.peraca} fue creado satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarPeraca = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarPeraca({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'El periodo academico fue actualizado satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarPeraca = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarPeraca(id)
          const message = `El periodo academico ${data} fue eliminado satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarPeraca = async (value) => {
    queryClient.prefetchQuery(key, () => getPeracas(value))
  }

  return {
    obtenerPeracas: useObtenerPeraca,
    handleEliminarPeraca,
    handleActualizarPeraca,
    handleCrearPeraca,
    handleBuscarPeraca,
  }
}
